import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../themes';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import styled from 'styled-components';
import NameDropDown from '../navigation/NameDropdown';
import decode from 'jwt-decode';

const NameContainer = styled.div`
  margin-top: 20px;
`;

const useStyles = makeStyles((theme) => {
  const time = i18n.t('common.time');
  return {
    changeCustomerContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowWrap: 'break-word',
      width: 320,
      [theme.breakpoints.down(450)]: {
        width: 300,
      },
      paddingBottom: 20,
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      marginRight: -12,
    },
    informationSection: {
      marginTop: theme.spacing(4),
    },
    accessLevelsSection: {
      marginTop: theme.spacing(4),
    },
    formFieldsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      '& .MuiInputBase-input': {
        color: Colors.black,
      },
      '& .react-datepicker-time__header': {
        visibility: 'hidden',
        '&::before': {
          content: `'  ${time}'`,
          visibility: 'visible',
          paddingLeft: 14,
        },
      },
    },
    textField: {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(4),
      width: 220,
      [theme.breakpoints.down(580)]: {
        width: 250,
      },
      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottom: `2px solid ${Colors.hoverGrey}`,
      },
    },
    button: {
      fontSize: 14,
      color: Colors.black,
      border: `1px solid ${Colors.disabledGrey}`,
      '&:hover': {
        background: Colors.disabledGrey,
        color: Colors.white,
      },
    },
  };
});

const ChangeCustomerModal = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    title,
    onClose,
    customerId,
    distributors,
    distributorInfo,
    distributorId,
    customers,
    getCustomersForController,
    isSystemAdmin,
    isDistributorAdmin,
    selectDistributor,
    selectCustomer,
  } = props;

  const customerIdSub = customerId ? decode(customerId)?.sub : '';
  const distributorIdSub = distributorId ? decode(distributorId)?.sub : '';

  return (
    <div className={classes.changeCustomerContainer}>
      <div className={classes.header}>
        <Typography variant="h2" id="modal-title">
          {title}
        </Typography>
        <IconButton className={classes.closeButton} key="close" aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      </div>
      <NameContainer className="SidebarHeader__NameContainer">
        <NameDropDown
          isLight
          data={isSystemAdmin ? distributors : [distributorInfo]}
          type={t('distributor')}
          disabled={!isSystemAdmin}
          isDistributor={true}
          defaultCompanyId={distributorIdSub}
          onSelect={(sub) => {
            const selectedDistributor = distributors?.find((distributor) => distributor.distributorIdSub === sub);
            const selectedDistributorId = selectedDistributor?.distributorId;
            const selectedDistributorName = selectedDistributor?.address?.fullName;
            selectDistributor(selectedDistributorId, selectedDistributorName);
            selectedDistributorId && getCustomersForController(selectedDistributorId);
          }}
        />
        <NameDropDown
          isLight
          data={customers.length > 0 ? customers : []}
          type={t('customer.customer')}
          disabled={!(isSystemAdmin || isDistributorAdmin) || customers.length === 0}
          isDistributor={false}
          defaultCompanyId={customerIdSub}
          noEntry={`-${t('customer.noCustomer')}-`}
          onSelect={(sub) => {
            const selectedCustomer = customers.find((customer) => customer.customerIdSub === sub);
            const selectedCustomerId = selectedCustomer?.customerId;
            const selectedCustomerName = selectedCustomer?.address?.fullName;
            selectedCustomerId && selectCustomer(selectedCustomerId, selectedCustomerName);
          }}
        />
      </NameContainer>
    </div>
  );
};

export default ChangeCustomerModal;
